import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Box } from '@mui/material';
import ChatWindowHeader from './ChatWindowHeader/ChatWindowHeader';
import ChatWindowBody from './ChatWindowBody/ChatWindowBody';
import ChatWindowFooter from './ChatWindowFooter/ChatWindowFooter';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

import useChatContext from '../../hooks/useChatContext/useChatContext';
import { useAppState } from '../../state';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      overflow: 'hidden',
      background: '#FFFFFF',
      zIndex: 100,
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      height: '100%',
      [theme.breakpoints.down('sm')]: {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
      },
    },
  })
);

export default function ChatWindow() {
  const classes = useStyles();
  const { isChatWindowOpen } = useChatContext();
  const { user } = useAppState();

  //if chat window is not open, don't render this component
  if (!isChatWindowOpen) return null;

  // The message list has its own boundary: a message it cannot render must not take the call down with it.
  // The fallback is an empty spacer that keeps the footer in place; closing the chat unmounts the boundary,
  // so opening it again starts from a clean state.
  return (
    <aside className={classes.container}>
      <ChatWindowHeader />
      <ErrorBoundary fallBackComponent={() => <Box sx={{ flexGrow: 1 }} />} user={user}>
        <ChatWindowBody />
      </ErrorBoundary>
      <ChatWindowFooter />
    </aside>
  );
}
